const siteEventNames = {
  ADD_SWATCH: 'addswatch',
  ERROR_404: '404error',
  ON_MODAL_CLOSE: 'onmodalclose',
  ON_MODAL_OPEN: 'onmodalopen',
  REMOVE_SWATCH: 'removeswatch',
  SITE_ERROR: 'siteerror',
};

const initSiteEvents = () => {
  if (window.siteEventRegistry) {
    return;
  }
  // Init events and add them to window scope here
  window.siteEventRegistry = {};
  Object.keys(siteEventNames).forEach((key) => {
    const value = siteEventNames[key];
    siteEventRegistry[value] = {
      event: new Event(value),
      data: {},
    }
  });
};

const getEventData = (eventName) => {
  const { siteEventRegistry } = window;
  let data = {};
  Object.keys(siteEventRegistry).forEach((key) => {
    if (key === eventName) {
      data = siteEventRegistry[key].data;
    }
  });
  return data;
}

const dispatchSiteEvent = (eventName, data) => {
  const { siteEventRegistry } = window;
  Object.keys(siteEventRegistry).forEach((key) => {
    if (key === eventName) {
      const event = siteEventRegistry[key].event;
      siteEventRegistry[key].data = data;
      window.dispatchEvent(event);
    }
  });
};

export {
  dispatchSiteEvent,
  getEventData,
  initSiteEvents,
  siteEventNames,
};
